import img63 from '../EquipoMedico/img63.jpg'
import { Footer } from './Footer'
import React, { Component } from 'react'
import { Card, Row, Col, Container } from 'react-bootstrap'
import { Header } from './Header' // Usando Header para mantener consistencia con tus otros archivos en inglés

export class FeClinical extends Component {
    render() {
        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Clinical</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Centramos la Card y le damos un ancho del 80% (lg={8}) 
                        para que el contenido denso de la imagen se aprecie perfectamente.
                    */}
                    <Row className="justify-content-center">
                        <Col xs={12} md={10} lg={8}>
                            <Card className="shadow border-0 text-center">
                                <Card.Body className="p-3">
                                    <Card.Img 
                                        variant="top" 
                                        src={img63} 
                                        style={{ 
                                            width: '100%', 
                                            height: 'auto', 
                                            maxHeight: '900px', 
                                            objectFit: 'contain' 
                                        }} 
                                    />
                                </Card.Body>
                                <Card.Footer className="bg-white border-0">
                                    <Card.Title style={{ fontSize: '1.8rem', padding: '10px' }}>
                                        Consultations and Examinations
                                    </Card.Title>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}